export const archiveTypes = ['application/x-zip-compressed', 'application/zip'];
